var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelAboutInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.866026C11.4282 0.330127 12.5718 0.330127 13.5 0.866025L20.4593 4.88397C21.3875 5.41987 21.9593 6.41025 21.9593 7.48205V15.5179C21.9593 16.5897 21.3875 17.5801 20.4593 18.116L13.5 22.134C12.5718 22.6699 11.4282 22.6699 10.5 22.134L3.54071 18.116C2.6125 17.5801 2.04071 16.5897 2.04071 15.5179V7.48205C2.04071 6.41025 2.6125 5.41987 3.54071 4.88397L10.5 0.866026Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7308 19V9.4H13.2692V19H10.7308ZM12 7.64C11.5692 7.64 11.2077 7.51333 10.9154 7.26C10.6385 7.00667 10.5 6.69333 10.5 6.32C10.5 5.94667 10.6385 5.63333 10.9154 5.38C11.2077 5.12667 11.5692 5 12 5C12.4462 5 12.8077 5.12667 13.0846 5.38C13.3615 5.63333 13.5 5.94667 13.5 6.32C13.5 6.69333 13.3615 7.00667 13.0846 7.26C12.8077 7.51333 12.4462 7.64 12 7.64Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelAboutInfo);
export default __webpack_public_path__ + "static/media/selAboutInfo.1472c37bc392c2602a82405e1fcf7f53.svg";
export { ForwardRef as ReactComponent };